import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const WarningCircleSolidIcon = forwardRef<SVGSVGElement, IconProps>(function WarningCircleSolidIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 0C4.041 0 0 4.041 0 9C0 13.959 4.041 18 9 18C13.959 18 18 13.959 18 9C18 4.041 13.959 0 9 0ZM8.325 5.4C8.325 5.031 8.631 4.725 9 4.725C9.369 4.725 9.675 5.031 9.675 5.4V9.9C9.675 10.269 9.369 10.575 9 10.575C8.631 10.575 8.325 10.269 8.325 9.9V5.4ZM9.828 12.942C9.783 13.059 9.72 13.149 9.639 13.239C9.549 13.32 9.45 13.383 9.342 13.428C9.234 13.473 9.117 13.5 9 13.5C8.883 13.5 8.766 13.473 8.658 13.428C8.55 13.383 8.451 13.32 8.361 13.239C8.28 13.149 8.217 13.059 8.172 12.942C8.127 12.834 8.1 12.717 8.1 12.6C8.1 12.483 8.127 12.366 8.172 12.258C8.217 12.15 8.28 12.051 8.361 11.961C8.451 11.88 8.55 11.817 8.658 11.772C8.874 11.682 9.126 11.682 9.342 11.772C9.45 11.817 9.549 11.88 9.639 11.961C9.72 12.051 9.783 12.15 9.828 12.258C9.873 12.366 9.9 12.483 9.9 12.6C9.9 12.717 9.873 12.834 9.828 12.942Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
